module.exports = __webpack_public_path__ + "img/2019_p_l_s_s_b.748981cf.jpg";